/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';

import type { CommonResponseWrapper } from 'hems';

import type { WebHmiPasswordInfo, WebHmiPasswordSearchOptions } from 'hems/webHmiManagement';

export default class WebHmiManagementService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** Web HMI 비밀번호 조회 */
  getWebHmiPassword = async (params: WebHmiPasswordSearchOptions): Promise<WebHmiPasswordInfo> => {
    const { data } = await this.get<CommonResponseWrapper<WebHmiPasswordInfo>>(
      apiWrapper.managerApi('/managements/security/ems/web/hmi/passwords'),
      params
    );

    return data;
  };
}

export { WebHmiManagementService };
